import { styled, Typography } from "@mui/material";
import { useState } from "react";
import Linkify from "react-linkify";

const TextWrapper = styled("p")(({ theme }) => ({
  width: "100%",
  overflow: "hidden",
  whiteSpace: "break-spaces",
  wordWrap: "break-word",
  a: {
    color: "#000080",
  },
  ".expandable_text_action": {
    color: theme.palette.grey["600"],
    cursor: "pointer",
  },
}));

export default function ExpandableText({
  value,
  notExpandedSize = 100,
  className,
  ...rest
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpand = () => {
    setIsExpanded(true);
  };
  const handleContract = () => {
    setIsExpanded(false);
  };

  const contractedValue = value.slice(0, notExpandedSize);

  return (
    <TextWrapper className={`expandable_text ${className}`} {...rest}>
      {isExpanded ? (
        <>
          <Typography>{value}</Typography>
          <br />
          <span onClick={handleContract} className="expandable_text_action">
            Ver menos
          </span>
        </>
      ) : (
        <>
          <Linkify>{contractedValue}</Linkify>
          {value.length > notExpandedSize && (
            <span onClick={handleExpand} className="expandable_text_action">
              {" "}
              ...Ver mais
            </span>
          )}
        </>
      )}
    </TextWrapper>
  );
}
